import React, {type ReactNode} from 'react';
import classNames from 'classnames';

import {TypographySize, useTypography} from '@time-webkit/all/hooks/typography';

import styles from './wrapper.module.css';

export const EditorWrapper = ({children}: {children: ReactNode}) => {
    const textCls = useTypography({size: TypographySize.BodyL});

    return (
        <div className={styles.wrapper} data-testid='form_create_post'>
            <div className={classNames(textCls, styles.textBox)}>
                {children}
            </div>
        </div>
    );
};
